import {defineStore} from 'pinia';
import {DataService} from '../../api';
import {loadPluginMenu, loadPluginPanel} from '../../utils/pluginConfigLoader';

export const usePluginStore = defineStore('plugin', {
  state: () => ({
    plugins: [],
    menuItems: [],
    panels: {},
  }),

  getters: {
    pluginList: (state) => state.plugins,
    sidebarMenuItems: (state) => state.menuItems,
    pluginPanels: (state) => state.panels
  },

  actions: {
    async initPluginStore() {
      await this.initPlugins();
    },

    async initPlugins() {
      try {
        const res = await DataService.read('config', {
          attributes: 'value',
          filters: {label: 'eq.custom.plugins.load'},
        });
        if (res?.data && res?.data.length > 0) {
          this.plugins = Array.isArray(res.data[0].value)
            ? res.data[0].value
            : [];
          await Promise.all([
            this.generateMenuItemsList(this.plugins),
            this.generatePanels(this.plugins),
          ]);
        }
      } catch (error) {
        console.error('Error loading plugins', error);
      }
    },

    async generateMenuItemsList(pluginList) {
      let menuItems = [];
      for (const plugin of pluginList) {
        try {
          const {default: getMenuItems} = await loadPluginMenu(plugin);
          menuItems = menuItems.concat(getMenuItems());
        } catch (error) {
          console.error(`Error loading menu for plugin: ${plugin}`, error);
        }
      }
      this.menuItems = menuItems;
    },

    async generatePanels(pluginList) {
      let panels = {};
      for (const plugin of pluginList) {
        try {
          const {default: getPanels} = await loadPluginPanel(plugin);
          const pluginPanels = getPanels();
          for (const panel of pluginPanels) {
            if (!(panel?.target in panels)) {
              panels[panel.target] = [];
            }
            const resolvedPanel = {
              ...panel,
              panel: (await panel.panel()).default,
            };
            panels[panel.target].push(resolvedPanel);
          }
        } catch (error) {
          console.error(`Error generating panels for plugin: ${plugin}`, error);
        }
      }
      this.panels = panels;
    },

    getHiddenPanels(viewName) {
      if (viewName === "projectPartDetail" && this.plugins.includes("alpha-beton")) {
        return ["information"];
      }
      return [];
    },

    getViewPanels (viewName) {
      return this.panels?.[viewName] ?? [];
    }
  },
});